import z from 'zod';

import { AbTestTeasers, Metadata } from '../metadata/schemas';

export const AB_TEST_STATUS = {
    INITIALIZED: 'initialized',
    RUNNING: 'running',
    STOPPED: 'stopped',
    COMPLETED: 'completed',
} as const;

export type AbTestStatus = ValueOf<typeof AB_TEST_STATUS>;

const AbTestResult = z.object({
    pageImpressions: z.number(),
});

const AbTestResults = z.object({
    a: AbTestResult,
    b: AbTestResult,
});

const AbTestInitialized = z.object({
    status: z.literal(AB_TEST_STATUS.INITIALIZED),
    startTime: z.string().nullish(),
    endTime: z.string().nullish(),
});

const AbTestRunning = z.object({
    status: z.literal(AB_TEST_STATUS.RUNNING),
    startTime: z.string(),
    endTime: z.string(),
});

type AbTestRunning = z.infer<typeof AbTestRunning>;

export const AbTestStopped = z.object({
    status: z.literal(AB_TEST_STATUS.STOPPED),
    startTime: z.string().optional(),
    endTime: z.string().optional(),
});

export type AbTestStopped = z.infer<typeof AbTestStopped>;

const AbTestCompleted = z.object({
    status: z.literal(AB_TEST_STATUS.COMPLETED),
    startTime: z.string(),
    endTime: z.string(),
    significance: z.number().optional(),
    results: AbTestResults.optional(),
    teasers: AbTestTeasers.optional(),
});

export type AbTestCompleted = z.infer<typeof AbTestCompleted>;

export const AbTest = z.discriminatedUnion('status', [
    AbTestInitialized,
    AbTestRunning,
    AbTestStopped,
    AbTestCompleted,
]);

export type AbTest = z.infer<typeof AbTest>;

export const AbTestListItem = z.object({
    metadataId: Metadata.shape.id,
    resourceId: z.string(),
    resourceName: z.string(),
    status: z.enum(AB_TEST_STATUS),
    significance: z.number().optional(),
    startTime: z.string().nullish(),
    endTime: z.string().nullish(),
    targetDateTime: z.string().nullish(),
    results: AbTestResults.optional(),
    teasers: AbTestTeasers.optional(),
});
export type AbTestListItem = z.infer<typeof AbTestListItem>;
